"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

/**
 * @enum {string}
 * @alias InputRow.rowAlignments
 */
var rowAlignments = {
  /** top */
  TOP: "top",

  /** bottom */
  BOTTOM: "bottom"
};
/**
 * @class InputRow
 * @desc A single horizontal line for one or more inputs
 *
 * @param {string} [data-id="input-row"]
 *          To define the base "data-id" value for the top-level HTML container.
 * @param {string} [className]
 *      css parameter
 * @param {boolean} [strict]
 *      adds flexbox styling to row
 * @param {InputRow.rowAlignments} [align=rowAlignments.BOTTOM]
 *      whether to align elements to the top or the bottom
 * @example
<InputRow>
    <FormTextField
        labelText="First Name"
        width={InputWidths.SM}
        data-id="firstName"
        required={true}
    />
    <FormTextField
        labelText="Last Name"
        width={InputWidths.SM}
        data-id="firstName"
        required={true}
    />
</InputRow>
 */

var InputRow = function InputRow(_ref) {
  var alignment = _ref.alignment,
      children = _ref.children,
      className = _ref.className,
      dataId = _ref["data-id"],
      strict = _ref.strict;
  var classNames = (0, _classnames.default)("input-row input-row--line-height", className, {
    "input-row--strict": strict,
    "input-row--top": alignment === rowAlignments.TOP
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-id": dataId,
    className: classNames
  }, children);
};
/**
 * @class InputRow.InputRowAccessories
 * @desc A wrapper for text, buttons, etc to ensure it vertically aligns with the input portion of a FormTextField
 *
 * @param {string} [data-id="input-row"]
 *          To define the base "data-id" value for the top-level HTML container.
 * @example
<InputRow>
    <FormTextField
        labelText="First Name"
        width={InputWidths.SM}
        data-id="firstName"
        required={true}
    />
    <RowAccessories>
        <Button inline>This will be vertically aligned</Button>
    </RowAccessories>
</InputRow>
 */


InputRow.InputRowAccessories = function (_ref2) {
  var children = _ref2.children,
      dataId = _ref2["data-id"];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "input-row__accessories",
    "data-id": dataId
  }, children);
};

InputRow.propTypes = {
  alignment: _propTypes.default.oneOf((0, _values.default)(rowAlignments)),
  "data-id": _propTypes.default.string,
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  strict: _propTypes.default.bool
};
InputRow.defaultProps = {
  alignment: rowAlignments.BOTTOM,
  "data-id": "input-row"
};
InputRow.rowAlignments = rowAlignments;
var _default = InputRow;
exports.default = _default;
module.exports = exports["default"];